export default __webpack_public_path__ + "static/media/RandomIdeas400.07fc94ea.jpg";